export let otherForProfit = {
    title: 'Other For Profit',

    records: [
        {
            suitable_for_solar: "Varies",
            example_system_size: 50,
            total_number_of_panels: 85,
            estimated_system_cost: "200,000",
            estimated_rebate: "-",
            estimated_fit_credit: "60,000",
            estimated_accelerated_deprecation: "59,500",
            annual_energy_savings: "6,850",
            monthly_energy_savings: 571,
            lifetime_energy_savings: "205,673",
            avg_cost_solar_power: "0.0520",
            current_power_costs: "0.1000",
            payback_period: 10,
            net_investment: "80,500"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 150,
            total_number_of_panels: 255,
            estimated_system_cost: "345,000",
            estimated_rebate: "-",
            estimated_fit_credit: "103,500",
            estimated_accelerated_deprecation: "102,638",
            annual_energy_savings: "20,550",
            monthly_energy_savings: "1,713",
            lifetime_energy_savings: "617,078",
            avg_cost_solar_power: "0.0308",
            current_power_costs: "0.1000",
            payback_period: 6,
            net_investment: "138,862"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 300,
            total_number_of_panels: 510,
            estimated_system_cost: "630,000",
            estimated_rebate: "-",
            estimated_fit_credit: "189,000",
            estimated_accelerated_deprecation: "187,425",
            annual_energy_savings: "41,100",
            monthly_energy_savings: "3,425",
            lifetime_energy_savings: "1,234,037",
            avg_cost_solar_power: "0.0283",
            current_power_costs: "0.1000",
            payback_period: 6,
            net_investment: "253,575"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 650,
            total_number_of_panels: 1102,
            estimated_system_cost: "1,332,500",
            estimated_rebate: "-",
            estimated_fit_credit: "399,750",
            estimated_accelerated_deprecation: "396,419",
            annual_energy_savings: "89,050",
            monthly_energy_savings: "7,421",
            lifetime_energy_savings: "2,673,746",
            avg_cost_solar_power: "0.0277",
            current_power_costs: "0.1000",
            payback_period: 6,
            net_investment: "536,331"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 1200,
            total_number_of_panels: 2034,
            estimated_system_cost: "2,400,000",
            estimated_rebate: "-",
            estimated_fit_credit: "720,000",
            estimated_accelerated_deprecation: "714,000",
            annual_energy_savings: "164,400",
            monthly_energy_savings: "13,700",
            lifetime_energy_savings: "4,936,147",
            avg_cost_solar_power: "0.0271",
            current_power_costs: "0.1000",
            payback_period: 5.75,
            net_investment: "966,000"
        },
    ],

    status: 'checked'
}

export let otherNonProfit = {
    title: 'Other Non Profit',

    records: [
        {
            suitable_for_solar: "Varies",
            example_system_size: 50,
            total_number_of_panels: 85,
            estimated_system_cost: "200,000",
            estimated_rebate: "-",
            estimated_fit_credit: "60,000",
            estimated_accelerated_deprecation: "-",
            annual_energy_savings: "6,850",
            monthly_energy_savings: 571,
            lifetime_energy_savings: "205,673",
            avg_cost_solar_power: "0.0520",
            current_power_costs: "0.1000",
            payback_period: 10,
            net_investment: "140,000"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 150,
            total_number_of_panels: 255,
            estimated_system_cost: "345,000",
            estimated_rebate: "-",
            estimated_fit_credit: "103,500",
            estimated_accelerated_deprecation: "-",
            annual_energy_savings: "20,550",
            monthly_energy_savings: "1,713",
            lifetime_energy_savings: "617,078",
            avg_cost_solar_power: "0.0308",
            current_power_costs: "0.1000",
            payback_period: 6,
            net_investment: "241,500"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 300,
            total_number_of_panels: 510,
            estimated_system_cost: "630,000",
            estimated_rebate: "-",
            estimated_fit_credit: "189,000",
            estimated_accelerated_deprecation: "-",
            annual_energy_savings: "41,100",
            monthly_energy_savings: "3,425",
            lifetime_energy_savings: "1,234,037",
            avg_cost_solar_power: "0.0283",
            current_power_costs: "0.1000",
            payback_period: 6,
            net_investment: "441,000"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 650,
            total_number_of_panels: 1102,
            estimated_system_cost: "1,332,500",
            estimated_rebate: "-",
            estimated_fit_credit: "399,750",
            estimated_accelerated_deprecation: "-",
            annual_energy_savings: "89,050",
            monthly_energy_savings: "7,421",
            lifetime_energy_savings: "2,673,746",
            avg_cost_solar_power: "0.0277",
            current_power_costs: "0.1000",
            payback_period: 6,
            net_investment: "932,750"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 1200,
            total_number_of_panels: 2034,
            estimated_system_cost: "2,400,000",
            estimated_rebate: "-",
            estimated_fit_credit: "720,000",
            estimated_accelerated_deprecation: "-",
            annual_energy_savings: "164,400",
            monthly_energy_savings: "13,700",
            lifetime_energy_savings: "4,936,147",
            avg_cost_solar_power: "0.0271",
            current_power_costs: "0.1000",
            payback_period: 5.75,
            net_investment: "1,680,000"
        },
    ],

    status: 'checked'
}

export let austinNonProfit = {
    title: 'Austin Non Profit',

    records: [
        {
            suitable_for_solar: "Varies",
            example_system_size: 50,
            total_number_of_panels: 85,
            estimated_system_cost: "200,000",
            estimated_rebate: "40,000",
            estimated_fit_credit: "72,000",
            estimated_accelerated_deprecation: "-",
            annual_energy_savings: "6,788",
            monthly_energy_savings: 566,
            lifetime_energy_savings: "203,822",
            avg_cost_solar_power: "0.0567",
            current_power_costs: "0.0991",
            payback_period: 12,
            net_investment: "88,000"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 150,
            total_number_of_panels: 255,
            estimated_system_cost: "345,000",
            estimated_rebate: "120,000",
            estimated_fit_credit: "139,500",
            estimated_accelerated_deprecation: "-",
            annual_energy_savings: "20,365",
            monthly_energy_savings: "1,697",
            lifetime_energy_savings: "611,465",
            avg_cost_solar_power: "0.0198",
            current_power_costs: "0.0991",
            payback_period: 4,
            net_investment: "85,500"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 300,
            total_number_of_panels: 510,
            estimated_system_cost: "630,000",
            estimated_rebate: "240,000",
            estimated_fit_credit: "261,000",
            estimated_accelerated_deprecation: "-",
            annual_energy_savings: "40,730",
            monthly_energy_savings: "3,394",
            lifetime_energy_savings: "1,222,930",
            avg_cost_solar_power: "0.0155",
            current_power_costs: "0.0991",
            payback_period: 3,
            net_investment: "129,000"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 650,
            total_number_of_panels: 1102,
            estimated_system_cost: "1,332,500",
            estimated_rebate: "385,542",
            estimated_fit_credit: "515,413",
            estimated_accelerated_deprecation: "-",
            annual_energy_savings: "88,249",
            monthly_energy_savings: "7,354",
            lifetime_energy_savings: "2,649,682",
            avg_cost_solar_power: "0.0227",
            current_power_costs: "0.0991",
            payback_period: 4.75,
            net_investment: "431,545"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 1200,
            total_number_of_panels: 2034,
            estimated_system_cost: "2,400,000",
            estimated_rebate: "385,542",
            estimated_fit_credit: "835,663",
            estimated_accelerated_deprecation: "-",
            annual_energy_savings: "162,920",
            monthly_energy_savings: "13,577",
            lifetime_energy_savings: "4,891,721",
            avg_cost_solar_power: "0.0326",
            current_power_costs: "0.0991",
            payback_period: 7,
            net_investment: "1,178,795"
        },
    ],

    status: 'checked'
}

export let austinForProfit = {
    title: 'Austin For Profit',

    records: [
        {
            suitable_for_solar: "Varies",
            example_system_size: 50,
            total_number_of_panels: 85,
            estimated_system_cost: "200,000",
            estimated_rebate: "-",
            estimated_fit_credit: "60,000",
            estimated_accelerated_deprecation: "59,500",
            annual_energy_savings: "12,268",
            monthly_energy_savings: "1,022",
            lifetime_energy_savings: "230,949",
            avg_cost_solar_power: "0.0520",
            current_power_costs: "0.0991",
            payback_period: 7.5,
            net_investment: "80,500"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 150,
            total_number_of_panels: 255,
            estimated_system_cost: "345,000",
            estimated_rebate: "-",
            estimated_fit_credit: "103,500",
            estimated_accelerated_deprecation: "102,638",
            annual_energy_savings: "36,805",
            monthly_energy_savings: "3,067",
            lifetime_energy_savings: "692,847",
            avg_cost_solar_power: "0.0308",
            current_power_costs: "0.0991",
            payback_period: 4,
            net_investment: "138,862"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 300,
            total_number_of_panels: 510,
            estimated_system_cost: "630,000",
            estimated_rebate: "-",
            estimated_fit_credit: "189,000",
            estimated_accelerated_deprecation: "187,425",
            annual_energy_savings: "73,610",
            monthly_energy_savings: "6,134",
            lifetime_energy_savings: "1,385,695",
            avg_cost_solar_power: "0.0283",
            current_power_costs: "0.0991",
            payback_period: 3.5,
            net_investment: "253,575"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 650,
            total_number_of_panels: 1102,
            estimated_system_cost: "1,332,500",
            estimated_rebate: "-",
            estimated_fit_credit: "399,750",
            estimated_accelerated_deprecation: "396,419",
            annual_energy_savings: "141,679",
            monthly_energy_savings: "11,807",
            lifetime_energy_savings: "2,914,174",
            avg_cost_solar_power: "0.0277",
            current_power_costs: "0.0991",
            payback_period: 4,
            net_investment: "536,331"
        },
        {
            suitable_for_solar: "YES",
            example_system_size: 1200,
            total_number_of_panels: 2034,
            estimated_system_cost: "2,400,000",
            estimated_rebate: "-",
            estimated_fit_credit: "720,000",
            estimated_accelerated_deprecation: "714,000",
            annual_energy_savings: "261,560",
            monthly_energy_savings: "21,797",
            lifetime_energy_savings: "5,380,014",
            avg_cost_solar_power: "0.0271",
            current_power_costs: "0.0991",
            payback_period: 4,
            net_investment: "966,000"
        },
    ],

    status: 'checked'
}